import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import ViewMaidM from "./M/ViewMaidM";
import { SysConfig } from "__SYSDefault/Config";
import ViewMaidW from "./W/ViewMaidW";

/**
 * @augments {Component<Props, State>}
 */
class ViewMaid extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(ViewMaid.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  render(){
    return ResponsiveX.Split({
      0: () => <ViewMaidM {...this.props} />,
      [SysConfig.WebUIWidth]: () => <ViewMaidW {...this.props} />
    });
  }

}

export default observer(ViewMaid);
